import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#00805d"} }, "Comprar nuevo plan")
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-title" }, "Error", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-header-close-icon pi pi-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: "",
    id: "p-dialog",
    header: "Error",
    draggable: false,
    closable: false,
    visible: $setup.store.state.ErrorDialog,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.store.state.ErrorDialog) = $event))
  }, {
    header: _withCtx(() => [
      _hoisted_5,
      _createElementVNode("button", {
        class: "p-dialog-header-icon p-dialog-header-close p-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.CerrarModalError && $setup.CerrarModalError(...args)))
      }, _hoisted_7)
    ]),
    footer: _withCtx(() => [
      ($setup.props.tipoError === 'SaldoInsuficiente')
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.ConfirmacionModal && $setup.ConfirmacionModal(...args))),
            value: "Comprar nuevo plan",
            class: "Button_BColorDegraded",
            style: {"font-weight":"bold"},
            id: "transmission-size"
          }))
        : _createCommentVNode("", true),
      ($setup.props.tipoError === 'TransmisionEnProceso' || $setup.props.tipoError === 'FalloCune')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            text: "",
            icon: "pi pi-times",
            onClick: $setup.ConfirmacionModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aceptar")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      ($setup.props.tipoError === 'SaldoInsuficiente')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createTextVNode(" Te quedaste sin saldo. No te preocupes, puedes seleccionar la opción: "),
            _hoisted_2,
            _createTextVNode(", para transmitir tu nómina. ")
          ]))
        : _createCommentVNode("", true),
      ($setup.props.tipoError === 'TransmisionEnProceso')
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Actualmente un grupo de nóminas se encuentra en proceso de validación. "))
        : _createCommentVNode("", true),
      ($setup.props.tipoError === 'FalloCune')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No es posible realizar la transmisión de nota de ajuste. Contáctenos "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}